import { PhysicalAttackSkill, StatusSkill, SpecialAttackSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";
import * as pred from "../../core/pred";

export const 死亡之尾 = new PhysicalAttackSkill(
    "死亡之尾",
    type.暗影,
    [
        "消除对手的回合类效果，消除成功则对手害怕",
        "命中后有15%的几率秒杀对手，对手处于能力下降状态时几率翻倍",
    ],
    80,
    [
        new Effect(new effect.消除回合(), Timing.onDamage, undefined, [
            new Effect(new effect.施加异常状态(new state.害怕()), Timing.triggered),
        ]),
        new Effect(new effect.秒杀(15), Timing.onDamage),
    ],
    3,
);

export const 黑暗操控 = new StatusSkill(
    "黑暗操控",
    [
        "3回合内，每回合有80%的几率令对手害怕，未触发则降低对手最大体力的1/3",
        "3回合内，若对手造成的伤害超过自身最大体力的1/2，则恢复自身最大体力的1/1并造成等量的固定伤害",
        "令对手全属性-1，对手不处于能力下降状态则额外使对手随机2个技能pp值归零",
        "4回合内，免疫并反弹异常状态",
    ],
    [],
);

export const 深渊逆流 = new SpecialAttackSkill(
    "深渊逆流",
    type.水,
    [
        "将能力下降状态反馈给对手，反馈成功则免疫下1次异常状态",
        "自身不处于能力下降状态则造成的伤害提高100%",
        "恢复自身最大体力的1/2并造成等量的固定伤害",
    ],
    120,
    [
        new Effect(new effect.回血·固伤(pred.自身最大体力的x分之一(2)), Timing.onDamage),
        new Effect(
            new effect.增伤(100),
            Timing.beforeDamage,
            cond.若自身不处于弱化状态,
        ),
    ],
    -1,
    true,
);

export const 暗影之力 = new StatusSkill(
    "暗影之力",
    [
        "全属性+1，对手不处于能力下降状态时强化效果翻倍",
        "3回合内，每回合攻击、速度等级+1",
        "4回合内，每回合吸取对手最大体力的1/3，体力低于1/2时吸取效果翻倍",
        "下2回合所有技能先制+2",
    ],
    [
        new Effect(
            new effect.强化(1, cond.若对手不处于弱化状态),
            Timing.onSkillHit,
        ),
        new RoundEffect(
            Timing.onSkillHit,
            4,
            new effect.吸取体力(pred.对手最大体力的x分之一(3), undefined, undefined, cond.若自身体力低于x分之一(2)),
            Timing.actionEnd,
            undefined,
            false,
            [],
        ),
    ],
);

export const 暗流深渊 = new PhysicalAttackSkill(
    "暗流深渊",
    type.水·暗影,
    [
        "先出手时必定打出致命一击",
        "后出手时造成伤害的50%恢复自身体力",
        "当回合未击败对手，则回合结束时自身攻击等级+2，并且下2回合先制+2",
        "当回合击败对手，则免疫下1次受到的攻击",
    ],
    150,
    [new Effect(new effect.暴击(), Timing.beforeDamage, cond.若先出手)],
);

export const 邪念潮汐断 = new SpecialAttackSkill(
    "邪念潮汐断",
    type.水·暗影,
    [
        "消除对手的能力提升，消除成功则下1回合必定先出手",
        "3回合内，对手无法通过技能恢复体力",
        "恢复自身最大体力的1/4并造成等量的固定伤害，体力低于1/2时恢复效果翻倍",
    ],
    160,
    [
        new Effect(new effect.消除强化(), Timing.onDamage),
        new Effect(
            new effect.回血·固伤(pred.自身最大体力的x分之一(4), undefined, undefined, cond.若自身体力低于x分之一(2)),
            Timing.onDamage,
        ),
    ],
    undefined,
    true,
);
